import React from 'react'
import desertmina_logo from "../images/logo-desertmina.jpeg";
import ReactPlayer from "react-player";
import distributor from "../images/distributor vidoe 1920X1080 final.jpg";
import ContactForm from './ContactForm';

function Booknow() {
  return (
    <div>
      <div className="distributorwater">
        <br />

        <div className="album py-0">
          <div className="container">
            <center>
              <img src={desertmina_logo} className="mb-2 mt-1" width="90" height="64" alt="DESERTMINA" />
            </center>
            <center>
              <h2 style={{ color: "#001a9bff" }}>DESERTMINA</h2>

            </center>

          </div>
        </div>

        <div className="album py-0">
          <div className="container">
           
              
            <div className="row">
              <div className="col-md-12 mt-1">

               <ContactForm/>
              </div>
              
            </div>
          </div>
        </div>
              <div className="album py-4">
          <div className="container">
                  <img src={distributor} className="d-block w-100" alt="distributor"/>
            
            </div>
          </div>
        <br />
        <br />
      </div>
    </div>
  )
}

export default Booknow